<template>
  <v-card>
    <v-row>
      <v-col
        lg="7"
        cols="12"
        class="pa-5"
        align-self="center"
      >
        <v-text-field
          v-if="oldPasswordNeeded"
          v-model="oldPassword"
          clearable
          :append-icon="showOldPassword ? 'far fa-eye' : 'far fa-eye-slash'"
          :type="showOldPassword ? 'text' : 'password'"
          hide-details
          outlined
          :label="$t('password.oldPassword')"
          class="mt-3 mb-3"
          @click:append="showOldPassword = !showOldPassword"
        />
        <v-text-field
          v-model="newPassword"
          clearable
          :append-icon="showNewPassword ? 'far fa-eye' : 'far fa-eye-slash'"
          :type="showNewPassword ? 'text' : 'password'"
          hide-details
          outlined
          :label="$t('password.newPassword')"
          class="mt-3 mb-3"
          @click:append="showNewPassword = !showNewPassword"
        />
        <v-text-field
          v-model="repeatPassword"
          clearable
          :append-icon="showRepeatNewPassword ? 'far fa-eye' : 'far fa-eye-slash'"
          :type="showRepeatNewPassword ? 'text' : 'password'"
          hide-details
          outlined
          :label="$t('password.repeatNewPassword')"
          class="mt-3 mb-3"
          @click:append="showRepeatNewPassword = !showRepeatNewPassword"
        />
      </v-col>
      <v-col
        lg="5"
        cols="12"
        align-self="center"
      >
        <v-list dense>
          <v-list-item v-if="oldPasswordNeeded">
            <v-list-item-action>
              <v-icon
                v-if="oldPasswordValid"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.oldPassword') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon
                v-if="containsNumber"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.numberRequired', { number: 1 }) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon
                v-if="containsUppercase"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.uppercaseRequired', { number: 1 }) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon
                v-if="containsSpecialChar"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.specialCharRequired', { number: 1 }) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon
                v-if="containsHeightChar"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.lengthRequired', { number: 8 }) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-icon
                v-if="identicalNewPassword"
                color="green"
              >
                fas fa-check
              </v-icon>
              <v-icon
                v-else
                color="red"
              >
                fas fa-times
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="list-text">
                {{ $t('password.identicalPassword') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer />
      <v-btn
        rounded
        class="elevation-0"
        color="tertiary"
        @click="resetForm"
      >
        {{ $t('password.reset') }}
      </v-btn>
      <v-btn
        :disabled="!formValid"
        rounded
        class="elevation-0"
        color="primary"
        @click="sendUpdatePassword"
      >
        {{ $t('password.edit') }}
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>
<script>
  export default {
    name: 'EditPassswordForm',
    props: {
      oldPasswordNeeded: Boolean,
    },
    data () {
      return {
        oldPassword: null,
        newPassword: null,
        repeatPassword: null,
        showOldPassword: false,
        showNewPassword: false,
        showRepeatNewPassword: false,
      }
    },
    computed: {
      oldPasswordValid () {
        return this.oldPassword !== '' && this.oldPassword != null
      },
      containsHeightChar: function () {
        let res = false
        if (this.newPassword != null) {
          res = this.newPassword.length >= 8
        }
        return res
      },
      containsNumber () {
        return /\d/.test(this.newPassword)
      },
      containsUppercase () {
        return /[A-Z]/.test(this.newPassword)
      },
      containsSpecialChar () {
        const format = /[!@#$%^&*()_+\-[\]{};':"\\|,.<>/?]/
        return format.test(this.newPassword)
      },
      identicalNewPassword () {
        return this.newPassword === this.repeatPassword
      },
      newPasswordValid () {
        return (
          this.containsHeightChar &&
          this.containsNumber &&
          this.containsUppercase &&
          this.containsSpecialChar
        )
      },
      formValid () {
        let isValid = this.identicalNewPassword && this.newPasswordValid
        if (this.oldPasswordNeeded) isValid = isValid && this.oldPasswordValid
        return isValid
      },
    },
    mounted () {
      if (!this.oldPasswordNeeded) this.oldPassword = ''
    },
    methods: {
      resetForm () {
        this.oldPassword = null
        this.newPassword = null
        this.repeatPassword = null
      },
      sendUpdatePassword () {
        let msgAlert
        this.setLoading(true)
        let dispatch
        const data = {
          password: this.newPassword,
          confirmation_password: this.repeatPassword,
        }
        if (this.oldPasswordNeeded) {
          data.old_password = this.oldPassword
          dispatch = 'updatePassword'
          msgAlert = this.$t('account.successUpdate')
        } else {
          dispatch = 'newPassword'
          msgAlert = this.$t('account.successNewPassword')
        }
        this.$store.dispatch(dispatch, data)
          .then(response => {
            this.resetForm()
            this.$store.dispatch('setAlert', { bool: true, type: 'success', text: msgAlert })
            if (!this.oldPasswordNeeded) {
              setTimeout(
                function () {
                  this.$router.push('/')
                  this.setLoading(false)
                }.bind(this),
                5000,
              )
            } else {
              this.setLoading(false)
            }
          })
          .catch(error => {
            console.error(error)
            this.setLoading(false)
            this.resetForm()
            this.$store.dispatch('setAlert', { bool: true, type: 'error', text: this.$t('account.errorUpdate') })
          })
      },
      setLoading (bool) {
        this.$store.dispatch('setLoading', { bool: bool, msg: this.$t('loader.editPassword') })
      },
    },
  }
</script>
<style scoped>
.list-text {
  font-size: 14px!important
}
</style>
